module.exports = __webpack_public_path__ + "assets/img/arrow-up-from-bracket-solid.51195227.svg";